import { ProductDetail } from '@api/catalog/types';

import AttributesItem from '@components/ProductCard/AttributesItem';
import CardTopBar from '@components/ProductCard/CardTopBar';

import { colors, scale, typography } from '@scripts/gds';

const ProductMoreInfo = ({ productItem }: { productItem: ProductDetail }) => {
    if (!productItem) {
        return null;
    }

    return (
        <div
            css={{
                width: scale(78),
                position: 'relative',
                display: 'flex',
            }}
        >
            <div
                css={{
                    width: '100%',
                    maxWidth: scale(68),
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    padding: `${scale(2)}px ${scale(3)}px`,
                }}
            >
                <p
                    css={{
                        marginTop: scale(1),
                        ...typography('bodyXSRegular'),
                        color: colors.textSecondGrey,
                    }}
                >
                    <AttributesItem productItem={productItem} />
                </p>
                <div
                    css={{
                        display: 'flex',

                        marginTop: scale(2),
                    }}
                >
                    <div
                        css={{
                            ...typography('bodyXSRegular'),
                            color: colors.textSecondGrey,
                            marginRight: scale(2),
                        }}
                    >
                        Продавец:
                    </div>

                    <div
                        css={{
                            textDecoration: 'underline',
                            ...typography('bodyXSRegular'),
                            WebkitBoxOrient: 'vertical',
                            display: '-webkit-box',
                            textOverflow: 'ellipsis',
                            WebkitLineClamp: 3,
                            overflow: 'hidden',
                        }}
                    >
                        {productItem.seller?.name}
                    </div>
                </div>
            </div>

            <div
                css={{
                    background: colors.backgroundMain,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '82px',
                }}
            >
                <CardTopBar
                    product={productItem}
                    css={{
                        gap: scale(4),
                        minWidth: scale(10),
                        backgroundColor: colors.backgroundMain,
                        padding: `${scale(4)}px ${scale(3)}px`,
                        '& button': {
                            boxShadow: '0px 4px 16px rgba(61, 123, 160, 0.25)',
                        },
                    }}
                />
            </div>
        </div>
    );
};

export default ProductMoreInfo;
